import React from 'react'

import {
  TagsList, ButtonFilter,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function MockedTagsRow() {
  return (
    <div className="cgt-model-search__tag-list">
      <div className="cgt-model-search__tag-list-tags">
        <div className="cgt-model-search__tag-list-body">
          <TagsList
            tags={['tag1', 'tag2']}
            Component={ButtonFilter}
          />
        </div>
      </div>
    </div>
  )
}

export default MockedTagsRow
